import { render, staticRenderFns } from "./PollutionalertsForm.vue?vue&type=template&id=264d0123"
import script from "./PollutionalertsForm.vue?vue&type=script&lang=js"
export * from "./PollutionalertsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports